module.exports = __webpack_public_path__ + "assets/salad_icon.db448fb9.svg";